<template>
  <div class="wrapper">
    <!-- 1.顶部标题 -->
    <el-row>
      <h3 class="title">
        <div class="block">
          <span>测试工具</span>
        </div>
      </h3>
    </el-row>
    <!-- 3.工具栏 -->
    <el-row>
      <div class="table-tool">
        <el-form class="form-flex" inline size="small" >
          <!-- 搜索内容 -->
          <el-form-item>
            <el-input
              class="selectInput"
              style="width:250px"
              placeholder="表单名称/所属应用/创建人/状态"
            >
              <svg slot="suffix" class="icon" aria-hidden="true" @click="searchTestToolLogList">
                <use xlink:href="#iconsearchicon" />
              </svg>
            </el-input>
          </el-form-item>
          <div>
            <el-form-item style="margin-right: 10px">
              <el-button type="primary">导入数据</el-button>
            </el-form-item>
            <el-form-item style="margin-right: 0">
              <el-button type="primary">测试</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-row>
    <el-scrollbar class="scrollbar-wrap">
      <!-- 3.表格区 -->
      <el-row>
        <el-table style="width:100%;" :data="tableData" tooltip-effect="light">
          <el-table-column
            label="触发话术"
            align="center"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="表单名称"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span class="table_span">{{ scope.row.form.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="所属应用"
            align="center"
          >
            <template slot-scope="scope">
              <span class="table_span">{{ scope.row.form.refApp }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="应填单数"
            align="center"
          >
            <template slot-scope="scope">
              <span class="table_span">{{ scope.row.quorum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="实际填单数"
            align="center"
          >
            <template slot-scope="scope">
              <span class="table_span">{{ scope.row.attended }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="准确率"
            align="center"
          >
            <template slot-scope="scope">
              <span class="table_span">{{ scope.row.accuracy }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" :show-overflow-tooltip="true">
            <template>
              <el-tooltip class="item" effect="light" content="查看" placement="bottom">
                <el-button
                  type="text"
                  @click="dialogVisible = true"
                >
                  <svg class="icon icon-bianji" aria-hidden="true">
                    <use xlink:href="#iconxiangqing" />
                  </svg>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 底部分页栏 -->
        <!--      <el-row style="float:right;">
                <el-pagination
                  background
                  class="pageStyle"
                  layout="total, prev, pager, next, jumper"
                  :page-size.sync="pageSize"
                  :current-page.sync="pageNum"
                  :total="total"
                  @current-change="handleCurrentChange"
                ></el-pagination>
              </el-row>-->

      </el-row>
    </el-scrollbar>
    <el-dialog :visible.sync="dialogVisible" class="text-left" width="480px">
      <div>
        <div class="text-block">
          <h5>自动填单内容如下：</h5>
          <div>
            <p>姓名：李方沪</p>
            <p>证件号码：320923XXXX</p>
          </div>
        </div>
        <div class="text-block">
          <h5>手动填单内容如下：</h5>
          <div>
            <p>电话：13888888888</p>
            <p>咨询事项：银行卡挂失</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button size="small" type="primary">确 认</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { getTestToolLogList } from '@/api/autofillform/testTool'

export default {
  name: 'app',
  data() {
    return {
      dialogVisible: false,
      tableData: []
    }
  },
  props: {
    autofillformFlag: Boolean
  },
  methods: {
    searchTestToolLogList () {
      const params = {
        page: 1,
        limit: 999
      }
      getTestToolLogList(params).then(response => {
        this.tableData = response.data.data.root
      }).catch(response => {
        this.tableData = []
      })
    }
  },
  mounted() {
    this.searchTestToolLogList()
  }
}
</script>
<style lang="scss">
.table-tool{margin:10px 0 4px;}
</style>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.scrollbar-wrap {
  height: calc(100% - 61px - 78px);
}
.form-flex {
  display: flex;
  justify-content: space-between;
}
.text-block {
  border-bottom: 1px solid #f2f2f2;
  font-size: 12px;
  color: #666;
  padding-top: 15px;
  padding-bottom: 15px;
  h5 {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
  }
}
</style>
